import { useState } from "react";

import useResizeObserver from "./useResizeObserver";

/**
 * Return true when the height of the element is taller than the passed in value.
 * @param {import("react").RefObject} ref
 * @param {number} param1.px
 * @param {any} param1.refreshTrigger - if this changes, the ref will be sent through the observer again.
 * @returns {boolean}
 */
const useIsTallerThan = (ref, { px = 719, refreshTrigger } = {}) => {
  const [isTallerThan, setIsTallerThan] = useState(
    ref.current?.clientHeight > px
  );

  // Using 17px to force double the width of a scrollbar of margin to trigger the change.
  useResizeObserver(
    ref,
    () => {
      setTimeout(() => {
        if (ref.current?.clientHeight - 17 > px) {
          setIsTallerThan(true);
        } else if (ref.current?.clientHeight + 17 < px) {
          setIsTallerThan(false);
        }
      });
    },
    refreshTrigger
  );
  return isTallerThan;
};

export default useIsTallerThan;
